import React from 'react';
import { IntlProvider } from 'react-intl';
import RouterProvider from '../../../providers/RouterProvider';
import ReduxProvider from '../../../providers/ReduxProvider';
import List from '..';

const WithProviders = (data = {}) => (
  <IntlProvider locale={data.locale}>
    <ReduxProvider>
      <RouterProvider
        routes={[
          {
            path: '*',
            element: <List data={data} />,
          },
        ]}
      />
    </ReduxProvider>
  </IntlProvider>
);

export default WithProviders;
